<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
          #{{fc.ID.value}}
        </div>
        <div class="row">
          <!-- Podvrsta dokumenta -->
          <div class="col-lg-2">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist
                 #ddlPodvrstaDokumentaStavka
                 [ModelName]="'podvrstadokumentastavka'"
                 [GetName]="'GetByUrl'"
                 [ModelProperty]="'Sifra,Naziv'"
                 [GetParameters]="modelData.MainList.GetParameters"
                 formControlName="PodVrstaDokumentaStavkaID"
                  [Label]="'FAKDOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                  [ngClass]="{
                    'is-invalid':
                      submitted && fc.PodVrstaDokumentaStavkaID.invalid
                  }"
                  (OnItemSelected)="onPodVrstaSelect($event)" [Width]="'600px'" #autofocus
                  [Required]="IsRequired('PodVrstaDokumentaStavkaID')"
                  [AutoSelect]="true"
                  [AllowAddNew]="true"
                  [Parameters]="parametersForPodvrstaDokumentStavka"
                  (GetItems)="PodvrstaDokumentaGetItems($event)"
                >
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                  <span *ngFor="
                      let validation of errorMessages.PodVrstaDokumentaStavkaID
                    ">
                    <span class="error-message" *ngIf="
                        fc.PodVrstaDokumentaStavkaID.hasError(validation.type)
                      ">
                      <span translate="{{ validation.message }}"></span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!--Odabir dokumenta -->
          <!-- <div class="col-lg-2">
          <div class="form-group row">
              <button 
                [disabled]="fc.ID.value != undefined"
                type="button" 
                class="btn btn-primary" 
                (click)="OdaberiDokument()">
                  Odabir dokumenta
                </button>
          </div>
        </div> -->
          <!-- Datum dokumenta -->
          <div class="col-lg-2 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                  #dtpDatumDokumenta
                  formControlName="Datum"
                  name="txtDatDok"
                  [Label]="'FAKDOKUMENT.DATDOK.SINGULAR'"
                  [ngClass]="{ 'is-invalid': submitted && fc.Datum.invalid }"
                  (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                  <span *ngFor="let validation of errorMessages.Datum">
                    <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Broj dokumenta -->
          <div class="col-lg-2 col-12">
            <div class="form-group row">
              <div class="col-md-8 col-8">
                <yt-input [Type]="'text'" [Label]="'FAKDOKUMENT.BRDOK.SINGULAR'" formControlName="Broj" [ngClass]="{
                    'is-invalid': submitted && fc.Broj.invalid
                  }">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                  <span *ngFor="let validation of errorMessages.Broj">
                    <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="input-group-append">
                  <span class="span-control">/</span>
                  <span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{
                    baseFormGroup.get("Datum").value.year }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Datum prometa-->
          <div class="col-lg-2 col-12" *ngIf="
              fcd && fcd['DatumPrometaOd'] && fcd['DatumPrometaOd'].IsVisible
            ">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="DatumPrometaOd" name="txtDatumPrometaOd"
                  [Label]="'FAKDOKUMENT.DATUMPROMETAOD.SINGULAR'" [ngClass]="{
                    'is-invalid': submitted && fc.DatumPrometaOd.invalid
                  }" (OnDateSelected)="onDatumPrometaOdChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatumPrometaOd.invalid">
                  <span *ngFor="let validation of errorMessages.DatumPrometaOd">
                    <span class="error-message" *ngIf="fc.DatumPrometaOd.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
                <!-- <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkDatumOd && !this.baseFormGroup.errors.checkDatumOd.valid"><span translate="{{this.baseFormGroup.errors.checkDatumOd.message}}"></span></span>
                </div> -->
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsOd && !this.baseFormGroup.errors.checkControlsOd.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsOd.message}}"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsPrometIOtpremnica && !this.baseFormGroup.errors.checkControlsPrometIOtpremnica.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsPrometIOtpremnica.message}}"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDatumPrometaOd && !this.baseFormGroup.errors.checkControlsDatumPrometaOd.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsDatumPrometaOd.message}}"></span></span>
                </div>
              </div>
             
            </div>
          </div>

          <div class="col-lg-2 col-12" *ngIf="
              fcd && fcd['DatumPrometaDo'] && fcd['DatumPrometaDo'].IsVisible
            ">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="DatumPrometaDo" name="txtDatumPrometaDo"
                  [Label]="'FAKDOKUMENT.DATUMPROMETADO.SINGULAR'" [ngClass]="{
                    'is-invalid': submitted && fc.DatumPrometaDo.invalid
                  }">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatumPrometaDo.invalid">
                  <span *ngFor="let validation of errorMessages.DatumPrometaDo">
                    <span class="error-message" *ngIf="fc.DatumPrometaDo.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDo && !this.baseFormGroup.errors.checkControlsDo.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsDo.message}}"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsPrometIOtpremnica && !this.baseFormGroup.errors.checkControlsPrometIOtpremnica.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsPrometIOtpremnica.message}}"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDatumPrometaDo && !this.baseFormGroup.errors.checkControlsDatumPrometaDo.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsDatumPrometaDo.message}}"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDatumDo && !this.baseFormGroup.errors.checkControlsDatumDo.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsDatumDo.message}}"></span></span>
                </div>    
              </div>
            </div>
          </div>
          <!-- Kraj Datuma prometa-->
           
           <div class="col-lg-2 col-12" *ngIf="
              fcd && fcd['DatumSmanjenja'] && fcd['DatumSmanjenja'].IsVisible
            ">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="DatumSmanjenja" name="txtDatumSmanjenja"
                  [Label]="'FAKDOKUMENT.DATUMSMANJENJA.SINGULAR'" [ngClass]="{
                    'is-invalid': submitted && fc.DatumSmanjenja.invalid
                  }">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatumSmanjenja.invalid">
                  <span *ngFor="let validation of errorMessages.DatumSmanjenja">
                    <span class="error-message" *ngIf="fc.DatumSmanjenja.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkDatumSmanjenja && !this.baseFormGroup.errors.checkDatumSmanjenja.valid"><span
                      translate="{{this.baseFormGroup.errors.checkDatumSmanjenja.message}}"></span></span>
                </div>     
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!--Komitent-->
          <div class="col-lg-3">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist
                 #ddlKomitent                 
                 [ModelName]="'komitent'"
                 [GetName]="'getByDrzava'"
                 [GetParameters]="parameterListZaKomitente"
                 [ModelProperty]="'SNaziv,Mesto'"
                 [OrderBy]="'SNaziv'"
                 [AllowAddNew]="true"
                 formControlName="KomitentID"
                 [Label]="'FAKDOKUMENT.KOMITENT.SINGULAR'"
                 [Width]="'xl'"
                 [Position]="'left'"                
                 (OnItemSelected)="onKomitentSelect($event)"
                 [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                  <span *ngFor="let validation of errorMessages.KomitentID">
                    <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!--Odabir predračuna-->
          <!-- <div class="col-lg-1">
              <div class="form-group row">
                  <button 
                    [disabled]="fc.ID.value == undefined"
                    type="button" 
                    class="btn btn-primary" 
                    (click)="UcitajAvanse()"
                    *ngIf="fcd && fcd['OdabirAvansa'] && fcd['OdabirAvansa'].IsVisible">
                      Odabir avansa
                    </button>
              </div>
            </div> -->

          <!--Način plaćanja-->
          <div class="col-lg-2" *ngIf="fcd && fcd['NacinPlacanjaID'] && fcd['NacinPlacanjaID'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist [ModelName]="'nacinplacanja'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'" [AllowAddNew]="false" formControlName="NacinPlacanjaID"
                  [Label]="'FAKDOKUMENT.NACINPLACANJA.SINGULAR'"
                  [ngClass]="{'is-invalid': submitted && fc.NacinPlacanjaID.invalid}">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.NacinPlacanjaID.invalid">
                  <span *ngFor="let validation of errorMessages.NacinPlacanjaID">
                    <span class="error-message" *ngIf="fc.NacinPlacanjaID.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!--Rok plaćanja u danima-->
          <div class="col-lg-1 col-12" *ngIf="fcd && fcd['RokDatDpo'] && fcd['RokDatDpo'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3
                  name="txtDani"
                  [Label]="'FAKDOKUMENT.ROKPLACANJAUDANIMA.SINGULAR'"
                  [FormatString]="'1.0-0'"
                  (OnBlur)="onDaniChange($event)" formControlName="Dani"
                >
                </yt-number-input-v3>

              </div>
            </div>
          </div>

          <!--Rok važenja u danima-->
          <div class="col-lg-1 col-12" *ngIf="fcd && fcd['RokVazenja'] && fcd['RokVazenja'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3 name="txtDaniVazenja" [Label]="'FAKDOKUMENT.ROKVAZENJAUDANIMA.SINGULAR'"
                  [FormatString]="'1.0-0'" (OnBlur)="onDaniVazenjaChange($event)" formControlName="DaniVazenja">
                </yt-number-input-v3>
              </div>
            </div>
          </div>

          <!--Datum valute-->
          <div class="col-lg-2 col-12" *ngIf="fcd && fcd['DatDpo'] && fcd['DatDpo'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="DatDpo" name="txtDatDpo"
                  [Label]=prevodDatumPlacanja
                  [ngClass]="{ 'is-invalid': submitted && fc.DatDpo.invalid }"
                  (OnDateSelected)="onDatDpoChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatDpo.invalid">
                  <span *ngFor="let validation of errorMessages.DatDpo">
                    <span class="error-message" *ngIf="fc.DatDpo.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDpo && !this.baseFormGroup.errors.checkControlsDpo.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsDpo.message}}"></span></span>
                </div>
              </div>
            </div>
          </div>

          <!--Rok važenja predračuna-->
          <div class="col-lg-2 col-12" *ngIf="fcd && fcd['RokVazenja'] && fcd['RokVazenja'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="RokVazenja" name="txtRokVazenja"
                  [Label]="'FAKDOKUMENT.ROKVAZENJA.SINGULAR'" [ngClass]="{
                    'is-invalid': submitted && fc.RokVazenja.invalid
                  }" (OnDateSelected)="onRokVazenjaChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.RokVazenja.invalid">
                  <span *ngFor="let validation of errorMessages.RokVazenja">
                    <span class="error-message" *ngIf="fc.RokVazenja.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsRokVazenja && !this.baseFormGroup.errors.checkControlsRokVazenja.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsRokVazenja.message}}"></span></span>
                </div>
              </div>
            </div>
          </div>
          <!-- Broj otpremnice -->
          <div class="col-lg-2 col-12" *ngIf="
              fcd && fcd['BrojOtpremnice'] && fcd['BrojOtpremnice'].IsVisible
            ">
            <div class="form-group row">
              <div class="col-md-12">
                <!-- <div class="col-md-8 col-8"> -->
                <yt-input [Type]="'text'" [Label]="'FAKDOKUMENT.BROJOTPREMNICE.SINGULAR'"
                  formControlName="BrojOtpremnice" [ngClass]="{
                    'is-invalid': submitted && fc.BrojOtpremnice.invalid
                  }">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.BrojOtpremnice.invalid">
                  <span *ngFor="let validation of errorMessages.BrojOtpremnice">
                    <span class="error-message" *ngIf="fc.BrojOtpremnice.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsBrojOtp && !this.baseFormGroup.errors.checkControlsBrojOtp.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsBrojOtp.message}}"></span></span>
                </div>
              </div>
            </div>
          </div>
          <!--Datum otpremnice-->
          <div class="col-lg-2 col-12" *ngIf="
              fcd && fcd['DatumOtpremnice'] && fcd['DatumOtpremnice'].IsVisible
            ">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="DatumOtpremnice" name="txtDatumOtpremnice"
                  [Label]="'FAKDOKUMENT.DATUMOTPREMNICE.SINGULAR'" [ngClass]="{
                    'is-invalid': submitted && fc.DatumOtpremnice.invalid
                  }" [isVisible]="'otpremnica'" (OnDateSelected)="onDatumOtpremniceChange($event)">
                </yt-fw-date-picker-popup>
                <!-- <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid"><span translate="{{this.baseFormGroup.errors.checkControls.message}}"></span></span>
              </div> -->
                <div class="form-error" *ngIf="submitted && fc.DatumOtpremnice.invalid">
                  <span *ngFor="let validation of errorMessages.DatumOtpremnice">
                    <span class="error-message" *ngIf="fc.DatumOtpremnice.hasError(validation.type)"><span
                        translate="{{ validation.message }}"></span></span>
                  </span>
                </div>
                <div class="form-error">
                  <span class="error-message" *ngIf="this.upozorenjeDatumOtpremnice"><span
                      translate="FAKDOKUMENT.DATUMOTPREMNICEOPSEGPROMET.VALIDATION.WARNING"></span></span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsOtpr && !this.baseFormGroup.errors.checkControlsOtpr.valid"><span
                      translate="{{this.baseFormGroup.errors.checkControlsOtpr.message}}"></span></span>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!--KomitentObjekat-->
          <div class="col-lg-3" *ngIf="fcd && fcd['KomitentObjekatID'] && fcd['KomitentObjekatID'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist [ModelName]="'komitentobjekat'" [GetName]="'getByKomitentID'"
                  [GetParameters]='parameterList' [ModelProperty]="'NazivObjekta,KomitentNaziv,MestoNaziv'"
                  [OrderBy]="'NazivObjekta'" [AllowAddNew]="true" formControlName="KomitentObjekatID"
                  [Label]="'FAKDOKUMENT.KOMITENTOBJEKAT.SINGULAR'" [Width]="'150%'" [Position]="'left'"
                  [Required]="false" [ParentProperty]="KomitentID">
                </yt-dropdown-picklist>

                <!-- <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                    <span *ngFor="let validation of errorMessages.KomitentID">
                      <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div> -->
              </div>
            </div>
          </div>
          <!-- Napomena -->
          <div class="col-lg-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-text-area [MaxLength]="500" name="txtNapomena" formControlName="Napomena"
                  [Label]="'FAKDOKUMENT.NAPOMENA.SINGULAR'"
                  [Height]="2">
                </yt-text-area>
                <div class="form-error" *ngIf="submitted && fc.Napomena.invalid">
                  <span *ngFor="let validation of errorMessages.Napomena">
                    <span class="error-message" *ngIf="fc.Napomena.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-lg-3 col-12" *ngIf="fcd && fcd['InstrukcijaZaPlacanje'] && fcd['InstrukcijaZaPlacanje'].IsVisible">
            <div class="form-group row">-->
              <!-- <div class="col-md-12"> -->
              <!--<div class="input-group">
                  <yt-text-area [MaxLength]="2000" name="txtInstrukcija" formControlName="InstrukcijaZaPlacanje"
                    [Label]="'FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.SINGULAR'"
                    [Height]="2"
                    class="flex-grow-1">
                  </yt-text-area>
                  <div class="form-error" *ngIf="submitted && fc.InstrukcijaZaPlacanje.invalid">
                    <span *ngFor="let validation of errorMessages.InstrukcijaZaPlacanje">
                      <span class="error-message" *ngIf="fc.InstrukcijaZaPlacanje.hasError(validation.type)"><span
                          translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
              <div class="input-group-append">-->
              <!-- <span class="input-group-append"> -->
                <!--<button type="button" class="btn" ngbTooltip="{{'FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.TOOLTIP' | translate }}"
                  placement="top" container="body" (click)="GetInstrukcije()"
                  [disabled]="disabledInstrukcije">
                  <span *ngIf="!disabledInstrukcije" class="fas fa-list"></span>
                </button>-->
              <!-- </span> -->
              <!--</div>
            </div>-->
          <!-- </div> -->
          <!--</div>
          </div>-->

          <!-- Napomena za poresko oslobođenje -->
          <!-- <div class="col-lg-4 col-12" *ngIf="Item.NapomenaZaPdvOsl != null && Item.NapomenaZaPdvOsl != ''"> -->

          <div class="col-lg-4 col-12" *ngIf="visibleNapomenaZaPdvOsl">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-text-area [MaxLength]="2000" name="txtNapomenaZaPdvOsl" formControlName="NapomenaZaPdvOsl"
                  [Label]="'FAKDOKUMENT.NAPOMENAZAPDVOSL.SINGULAR'"
                  [Height]="1">
                </yt-text-area>
                <div class="form-error" *ngIf="submitted && fc.NapomenaZaPdvOsl.invalid">
                  <span *ngFor="let validation of errorMessages.NapomenaZaPdvOsl">
                    <span class="error-message" *ngIf="fc.NapomenaZaPdvOsl.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Poresko oslobodjenje -->
          <!-- <div class="col-lg-2 col-12" *ngIf="false">
            <div class="form-group row">
              <div class="col-md-12">
                  <div class="btn-group mr-2">
                      <button class="btn btn-outline-primary" 
                              type="button" 
                              id="btnOdaberi" 
                              container="body"
                              (click)="DodajPoreskoOslobodjenje()" 
                              ngbTooltip="{{'FAKDOKUMENT.DODAJPORESKOOSLOBODJENJE.TOOLTIP' | translate }}">
                          <i class="fas fa-plus control-label"></i>
                          <span style="padding-left: 5px;" translate="FAKDOKUMENT.DODAJPORESKOOSLOBODJENJE.SINGULAR"></span>
                      </button>
                  </div>
              </div>
            </div>
          </div> -->
          <div class="col-lg-3 col-12" *ngIf="!visibleNapomenaZaPdvOsl">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist #ddlPoreskoOslobodjenje [ModelName]="'poreskooslobodjenje'" [GetName]="'get'"  
                  [ModelProperty]="'Key,Category,Naziv'"
                  [OrderBy]="'Key'" [AllowAddNew]="false" formControlName="PoreskoOslobodjenjeID"
                  [Label]="'FAKDOKUMENT.PORESKOOSLOBODJENJE.SINGULAR'" [Width]="'xl'" [Position]="'left'"
                  [Required]="false" 
                  (GetItems)="PoreskaOslobodjenjaGetItems($event)"
                  >
                </yt-dropdown-picklist>        
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message"
                    *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkPoreskoOslobodjenje && !this.baseFormGroup.errors.checkPoreskoOslobodjenje.valid"><span
                      translate="{{this.baseFormGroup.errors.checkPoreskoOslobodjenje.message}}"></span></span>
                </div>        
              </div>
             
            </div>
          </div>

          <div class="col-lg-2 col-12"
            *ngIf="
              fcd
              && fcd['VrstaDatumaPoreskeObavezeID']
              && fcd['VrstaDatumaPoreskeObavezeID'].IsVisible
            "
          >
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist
                  [ModelName]="'vrstadatumaporeskeobaveze'"
                  [GetName]="'get'"
                  [GetParameters]="vrstaDatumaPoreskeObavezeParam"
                  [ModelProperty]="'Opis'"
                  [OrderBy]="'Opis'"
                  [AllowAddNew]="false"
                  formControlName="VrstaDatumaPoreskeObavezeID"
                  [Label]="'FAKDOKUMENT.VRSTADATUMAPORESKEOBAVEZE.SINGULAR'" [Width]="'xl'" [Position]="'right'"
                  [FilterByAllColumns]="false"
                  [AutoSelect]="true"
                  [ngClass]="{
                    'is-invalid':
                      submitted && fc.VrstaDatumaPoreskeObavezeID.invalid
                  }"
                  [Required]="true"
                  (GetItems)="VrstaDatumaPoreskeObavezeGetItems($event)"
                >
                </yt-dropdown-picklist>
              </div>
              <div class="form-error" *ngIf="submitted && fc.VrstaDatumaPoreskeObavezeID.invalid">
                <span *ngFor="
                    let validation of errorMessages.VrstaDatumaPoreskeObavezeID
                  ">
                  <span class="error-message" *ngIf="
                      fc.VrstaDatumaPoreskeObavezeID.hasError(validation.type)
                    ">
                    <span translate="{{ validation.message }}"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>


          <!-- Odgovorno lice -->
          <!-- <div class="col-lg-3 col-12">
            <div class="form-group row" *ngIf="false">
              <div class="col-md-12">
                <yt-dropdown-picklist
                  [ModelName]="'osoba'"
                  [GetName]="'get'"
                  [ModelProperty]="'Prezime,Ime,Jmbg'"
                  [OrderBy]="'Prezime'"
                  [AllowAddNew]="false"
                  formControlName="OdgovornoLiceID"
                  [Label]="'FAKDOKUMENT.ODGOVORNOLICE.SINGULAR'"
                  [Width]="'800px'"
                  [Position]="'left'"
                  [Required]="false"
                >
                </yt-dropdown-picklist>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-6">
        <div class="form-group row" *ngIf="fcd && fcd['BrojUgovora'] && fcd['BrojUgovora'].IsVisible">
          <div class="col-md-12">            
            <yt-input [Type]="'text'" 
              [Label]="'FAKDOKUMENT.BROJUGOVORA.SINGULAR'"
              formControlName="BrojUgovora" 
              [ngClass]="{
                'is-invalid': submitted && fc.BrojUgovora.invalid
                  }"
              [MaxLength]="50">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.BrojUgovora.invalid">
                <span *ngFor="let validation of errorMessages.BrojUgovora">
                  <span class="error-message" *ngIf="fc.BrojUgovora.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
            <!-- <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
              <span class="error-message"
                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlBrojUgovora && !this.baseFormGroup.errors.checkControlBrojUgovora.valid"><span
                  translate="{{this.baseFormGroup.errors.checkControlBrojUgovora.message}}"></span></span>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Datum Ugovora -->
      <div class="col-md-2 col-4" *ngIf="fcd && fcd['DatumUgovora'] && fcd['DatumUgovora'].IsVisible
    ">
    <div class="form-group row">
      <div class="col-md-12">
        <yt-fw-date-picker-popup formControlName="DatumUgovora" name="txtDatumUgovora"
          [Label]="'FAKDOKUMENT.DATUMUGOVORA.SINGULAR'" [ngClass]="{
            'is-invalid': submitted && fc.DatumUgovora.invalid
          }" >
        </yt-fw-date-picker-popup>
       
        <div class="form-error" *ngIf="submitted && fc.DatumUgovora.invalid">
          <span *ngFor="let validation of errorMessages.DatumUgovora">
            <span class="error-message" *ngIf="fc.DatumUgovora.hasError(validation.type)"><span
                translate="{{ validation.message }}"></span></span>
          </span>
        </div>   
        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
          <span class="error-message"
            *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkDatumUgovora && !this.baseFormGroup.errors.checkDatumUgovora.valid"><span
              translate="{{this.baseFormGroup.errors.checkDatumUgovora.message}}"></span></span>
        </div>    
      </div>
    </div>
  </div>

      <!-- <div class="col-md-3 col-6">
        <div class="form-group row" *ngIf="fcd && fcd['BrojNarudzbenice'] && fcd['BrojNarudzbenice'].IsVisible">
          <div class="col-md-12">            
            <yt-input [Type]="'text'" 
              [Label]="'FAKDOKUMENT.BROJNARUDZBENICE.SINGULAR'"
              formControlName="BrojNarudzbenice" 
              [ngClass]="{
                'is-invalid': submitted && fc.BrojNarudzbenice.invalid
                  }"
              [MaxLength]="50">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.BrojNarudzbenice.invalid">
                <span *ngFor="let validation of errorMessages.BrojNarudzbenice">
                  <span class="error-message" *ngIf="fc.BrojNarudzbenice.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-lg-2 col-12" *ngIf="fcd && fcd['DatumNarudzbenice'] && fcd['DatumNarudzbenice'].IsVisible">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-fw-date-picker-popup 
              formControlName="DatumNarudzbenice" 
              name="txtDatumNarudzbenice"
              [Label]="'FAKDOKUMENT.DATUMNARUDZBENICE.SINGULAR'">
          </yt-fw-date-picker-popup>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-12" *ngIf="fcd && fcd['BrojPrijemnice'] && fcd['BrojPrijemnice'].IsVisible">
        <div class="form-group row">
          <div class="col-md-12">            
            <yt-input 
              [Type]="'text'" 
              [Label]="'FAKDOKUMENT.BROJPRIJEMNICE.SINGULAR'"
              formControlName="BrojPrijemnice" 
              [MaxLength]="50">
            </yt-input>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-12" *ngIf="fcd && fcd['DatumPrijemnice'] && fcd['DatumPrijemnice'].IsVisible">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-fw-date-picker-popup 
              formControlName="DatumPrijemnice" 
              name="txtDatumPrijemnice"
              [Label]="'FAKDOKUMENT.DATUMPRIJEMNICE.SINGULAR'">
          </yt-fw-date-picker-popup>
          </div>
        </div>
      </div>

      <div class="col-md-3 col-6" *ngIf="fcd && fcd['ReferencaKupcaNaDrugiDokument'] && fcd['ReferencaKupcaNaDrugiDokument'].IsVisible">
        <div class="form-group row">
          <div class="col-md-12">            
            <yt-input [Type]="'text'" 
              [Label]="'FAKDOKUMENT.REFERENCAKUPCANADRUGIDOKUMENT.SINGULAR'"
              formControlName="ReferencaKupcaNaDrugiDokument" 
              [MaxLength]="50">
            </yt-input>
          </div>
        </div>
      </div> -->
      <div class="col-md-3 col-6">
        <div class="row">
          <div class="col-md-6 col-6" *ngIf="fcd && fcd['ZaCrf'] && fcd['ZaCrf'].IsVisible">
            <div class="form-group row">
              <div class="col-md-12">                 
                <div class="form-check" style="padding-top: 22px">                
                  <input 
                      class="form-check-input" 
                      type="checkbox" 
                      formControlName="ZaCrf"
                      id="chkZaCrf"
                      Unosi se samo za subjekte javnog sektora.>
                  <label class="form-check-label" for="chkZaCrf" ngbTooltip="{{'KOMITENT.ZACRF.TOOLTIP' | translate }}">
                    <span translate="FAKDOKUMENT.ZACRF.SINGULAR"></span>
                  </label>                  
                </div>   
                        
              </div>
            </div>
          </div>
       <!-- Korekcija -->
       <!-- *ngIf="fcd && fcd['Korekcija'] && fcd['Korekcija'].IsVisible" -->
          <div class="col-md-6 col-6" *ngIf="fcd && fcd['KorekcijaVrednostiDokumenta'] && fcd['KorekcijaVrednostiDokumenta'].IsVisible">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-number-input-v3
                          name="txtKorekcija" 
                          [Label]="'FAKDOKUMENT.KOREKCIJAVREDNOSTIDOKUMENTA.SINGULAR'" 
                          formControlName="KorekcijaVrednostiDokumenta"
                          (OnBlur)="onKorekcijaSelect()">
                      </yt-number-input-v3>
                      <div class="form-error" *ngIf="submitted && fc.KorekcijaVrednostiDokumenta.invalid">
                          <span *ngFor="let validation of errorMessages.KorekcijaVrednostiDokumenta">
                              <span class="error-message" *ngIf="fc.KorekcijaVrednostiDokumenta.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                      </div>
                  </div>
              </div>
          </div>  
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12" *ngIf="fcd && fcd['InstrukcijaZaPlacanje'] && fcd['InstrukcijaZaPlacanje'].IsVisible">
        <div class="form-group row ">
          <div class="col-md-12 col-12">
            <div class="input-group">
               <button type="button" class="btn info-btn align-self-center"
                      [ngStyle]="{'color' : baseFormGroup.disabled ? '#ccc' : '#212529'}" 
                      ngbTooltip="{{'FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.INFO.TOOLTIP' | translate }}"
                      placement="top" container="body" (click)="GetInfo()"
                      [disabled]="baseFormGroup.disabled">
                <!-- <span *ngIf="!disabledInstrukcije" class="fas fa-info"></span> -->
                <i *ngIf="!disabledInstrukcije" class="fas fa-info"></i>
              </button>
              <button type="button" class="btn" [ngStyle]="{'color' : baseFormGroup.disabled ? '#ccc' : '#212529'}" 
                      ngbTooltip="{{'FAKDOKUMENT.INSTRUKCIJAZAPLACANJE.TOOLTIP' | translate }}"
                      placement="top" container="body" (click)="GetInstrukcije()"
                      [disabled]="baseFormGroup.disabled">
                <span *ngIf="!disabledInstrukcije" class="fas fa-list"></span>
              </button>
              <yt-text-area [MaxLength]="2000"
                            name="txtInstrukcija"
                            formControlName="InstrukcijaZaPlacanje"
                            [Label]="'FAKDOKUMENT.INSTRUKCIJAZAPLACANJA.SINGULAR'"
                            [Height]="2"
                            class="flex-grow-1">
              </yt-text-area>
              <div class="form-error" *ngIf="submitted && fc.InstrukcijaZaPlacanje.invalid">
                <span *ngFor="let validation of errorMessages.InstrukcijaZaPlacanje">
                  <span class="error-message" *ngIf="fc.InstrukcijaZaPlacanje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-6" *ngIf="fcd && fcd['ValutaID'] && fcd['ValutaID'].IsVisible">
        <div class="form-group row">
            <div class="col-md-12 col-12">
                <yt-dropdown-picklist 
                  [ModelName]="'valuta'" 
                  [GetName]="'get'" 
                  [ModelProperty]="'Naziv,Sifra,ISOAlpha3Code'" 
                  [OrderBy]="'ISOAlpha3Code'"
                  [AllowAddNew]="false" 
                  formControlName="ValutaID" 
                  [Label]="'FAKDOKUMENTIZVOZ.VALUTA.SINGULAR'"
                  [Width]="'xl'"
                  [Position]="'left'"
                  [FilterByAllColumns]="false"
                  (OnItemSelected)="onValutaSelected($event)"
                  >
                </yt-dropdown-picklist>
               
                <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
                    <span *ngFor="let validation of errorMessages.ValutaID">
                      <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
        </div>
      </div>
      <div class="col-md-3 col-6" *ngIf="fcd && fcd['Kurs'] && fcd['Kurs'].IsVisible">
          <div class="form-group row">
              <div class="col-md-12 col-12">
                  <yt-number-input-v3
                    name="txtKurs" 
                    [Label]="'FAKDOKUMENTIZVOZ.KURS.SINGULAR'" 
                    formControlName="Kurs"
                    (OnBlur)="onKursChange($event)"
                    [FormatString]="'1.4-4'">
                  </yt-number-input-v3>
                  <div class="form-error" *ngIf="submitted && fc.Kurs.invalid">
                      <span *ngFor="let validation of errorMessages.Kurs">
                        <span class="error-message" *ngIf="fc.Kurs.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
                 
              </div>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-12" *ngIf="fcd && fcd['MestoIsporukeRobe'] && fcd['MestoIsporukeRobe'].IsVisible">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
            [Type]="'text'"
            name="txtMestoIsporukeRobe"
            formControlName="MestoIsporukeRobe"
            #focusElement
            [ngClass]="{'is-invalid': submitted && fc.MestoIsporukeRobe.invalid}"
            [Label]="'FAKDOKUMENTIZVOZ.MESTOISPORUKEROBE.SINGULAR'">
          </yt-input>
            <div class="form-error" *ngIf="submitted && fc.MestoIsporukeRobe.invalid">
                <span *ngFor="let validation of errorMessages.MestoIsporukeRobe">
                  <span class="error-message" *ngIf="fc.MestoIsporukeRobe.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>   
          </div>
        </div>
      </div>
        <div class="col-md-4 col-12" *ngIf="fcd && fcd['MestoIzvrseneUsluge'] && fcd['MestoIzvrseneUsluge'].IsVisible"> 
        <div class="form-group row">
            <div class="col-md-12">
              <yt-input
              [Type]="'text'"
              name="txtMestoIzvrseneUsluge"
              formControlName="MestoIzvrseneUsluge"
              #focusElement
              [ngClass]="{'is-invalid': submitted && fc.MestoIzvrseneUsluge.invalid}"
              [Label]="'FAKDOKUMENTIZVOZ.MESTOIZVRSENEUSULUGE.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.MestoIzvrseneUsluge.invalid">
                  <span *ngFor="let validation of errorMessages.MestoIzvrseneUsluge">
                    <span class="error-message" *ngIf="fc.MestoIzvrseneUsluge.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div> 
            </div>
        </div>
      </div>
      <div class="col-md-4 col-12" *ngIf="fcd && fcd['KontaktOsoba'] && fcd['KontaktOsoba'].IsVisible"> 
        <div class="form-group row">
            <div class="col-md-12">              
              <yt-text-area [MaxLength]="300" name="txtKontaktOsoba" formControlName="KontaktOsoba"
                  [Label]="'FAKDOKUMENTIZVOZ.KONTAKTOSOBA.SINGULAR'"
                  [Height]="1">
              </yt-text-area>
              <div class="form-error" *ngIf="submitted && fc.KontaktOsoba.invalid">
                  <span *ngFor="let validation of errorMessages.KontaktOsoba">
                    <span class="error-message" *ngIf="fc.KontaktOsoba.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div> 
            </div>
        </div>
      </div>
    </div>


    <div class="row mb-2">
      <div class="col-md-12">
          <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-save mr-1"></span> <span translate="FW.ACTION.SAVE.ACTION"></span></button>
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"  [disabled]="saveDisabled"><span class="fa fa-undo mr-1"></span> <span translate="FW.ACTION.CANCEL"> </span></button>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <yt-fak-dokument-stavka-update-container
         #baseInlineContainer
          [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'FakDokumentID'"
          [ParentPropertyValue]="Item.ID" [Parameters]="TransferParameters">
        </yt-fak-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>
